import { StyleSheet } from 'react-native';
import FontFamily from '../../../../constants/fonts';
import { AdminColors } from '../../constants/adminColors';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: AdminColors.bgPage,
  },
  content: {
    padding: 24,
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 16,
    gap: 12,
  },
  pageTitle: {
    fontSize: 28,
    lineHeight: 40,
    color: AdminColors.gray800,
    fontFamily: FontFamily.bold,
  },
  pageSubtitle: {
    marginTop: 4,
    fontSize: 13,
    lineHeight: 18,
    color: AdminColors.gray350,
    fontFamily: FontFamily.regular,
  },
  infoBanner: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: AdminColors.blue200,
    backgroundColor: AdminColors.blue25,
    marginBottom: 16,
  },
  infoText: {
    flex: 1,
    fontSize: 13,
    lineHeight: 18,
    color: AdminColors.gray600,
    fontFamily: FontFamily.regular,
  },
  tableContainer: {
    backgroundColor: AdminColors.bgSurface,
    borderRadius: 8,
    shadowColor: '#005EC0',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.08,
    shadowRadius: 16,
    elevation: 2,
    overflow: 'hidden',
  },
  tableContentWrapper: {
    flex: 1,
  },
  tableToolbar: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: AdminColors.gray25,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  tableToolbarRight: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  clearFilterButton: {
    minHeight: 36,
    borderWidth: 2,
    borderColor: AdminColors.blue700,
    borderRadius: 999,
    paddingHorizontal: 18,
    paddingVertical: 6,
    backgroundColor: AdminColors.bgSurface,
    alignItems: 'center',
    justifyContent: 'center',
  },
  clearFilterText: {
    fontSize: 13,
    color: AdminColors.blue700,
    fontFamily: FontFamily.bold,
  },
  searchBox: {
    minWidth: 260,
    height: 34,
    borderWidth: 1,
    borderColor: AdminColors.gray100,
    borderRadius: 6,
    backgroundColor: AdminColors.bgSurface,
    paddingHorizontal: 10,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  searchBoxFocused: {
    borderWidth: 2,
    borderColor: AdminColors.blue700,
  },
  searchInput: {
    flex: 1,
    fontSize: 13,
    color: AdminColors.gray800,
    fontFamily: FontFamily.regular,
    paddingVertical: 6,
  },
  tableCount: {
    fontSize: 12,
    color: AdminColors.gray350,
    fontFamily: FontFamily.regular,
  },
  headerRowTable: {
    flexDirection: 'row',
    backgroundColor: AdminColors.bgSurface,
  },
  headerCell: {
    minHeight: 42,
    borderBottomWidth: 2,
    borderBottomColor: '#D7E5F8',
    paddingHorizontal: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 6,
    position: 'relative',
    zIndex: 2,
  },
  headerSortButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 6,
  },
  headerFilterButton: {
    width: 20,
    height: 20,
    borderRadius: 4,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: AdminColors.bgSurface,
  },
  headerCellText: {
    fontSize: 11,
    color: AdminColors.gray450,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    fontFamily: FontFamily.bold,
  },
  filterPopover: {
    position: 'absolute',
    width: 220,
    borderWidth: 1,
    borderColor: AdminColors.gray100,
    borderRadius: 8,
    backgroundColor: AdminColors.bgSurface,
    padding: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 4,
    zIndex: 30,
  },
  filterOverlayBackdrop: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  filterTextInput: {
    height: 34,
    borderWidth: 1,
    borderColor: AdminColors.gray100,
    borderRadius: 6,
    paddingHorizontal: 10,
    fontSize: 12,
    color: AdminColors.gray800,
    fontFamily: FontFamily.regular,
  },
  filterOptionsList: {
    maxHeight: 160,
  },
  filterOptionRow: {
    minHeight: 28,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 4,
  },
  filterOptionText: {
    fontSize: 12,
    color: AdminColors.gray600,
    fontFamily: FontFamily.regular,
  },
  filterActionsRow: {
    marginTop: 8,
    borderTopWidth: 1,
    borderTopColor: AdminColors.gray25,
    paddingTop: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  filterActionText: {
    fontSize: 12,
    color: AdminColors.blue700,
    fontFamily: FontFamily.medium,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: AdminColors.gray25,
    minHeight: 52,
  },
  tableCell: {
    paddingHorizontal: 10,
    paddingVertical: 10,
    justifyContent: 'center',
  },
  iconWrap: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: AdminColors.blue50,
    alignItems: 'center',
    justifyContent: 'center',
  },
  reportLink: {
    fontSize: 13,
    color: AdminColors.textLink,
    fontFamily: FontFamily.bold,
  },
  bodyText: {
    fontSize: 12,
    lineHeight: 17,
    color: AdminColors.gray600,
    fontFamily: FontFamily.regular,
  },
  linkText: {
    fontSize: 12,
    color: AdminColors.textLink,
    fontFamily: FontFamily.regular,
  },
  mutedText: {
    fontSize: 12,
    color: AdminColors.gray300,
    fontFamily: FontFamily.regular,
  },
  badgeWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
  },
  badge: {
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 4,
    alignSelf: 'flex-start',
  },
  badgeText: {
    fontSize: 11,
    fontFamily: FontFamily.medium,
  },
  tableFooter: {
    borderTopWidth: 1,
    borderTopColor: AdminColors.gray25,
    paddingHorizontal: 16,
    paddingVertical: 10,
  },
  tableFooterText: {
    fontSize: 12,
    color: AdminColors.gray350,
    fontFamily: FontFamily.regular,
  },
  formGroup: {
    marginBottom: 14,
  },
  formRow: {
    flexDirection: 'row',
    gap: 12,
  },
  flex1: {
    flex: 1,
  },
  formLabel: {
    marginBottom: 6,
    fontSize: 13,
    color: AdminColors.gray800,
    fontFamily: FontFamily.bold,
  },
  requiredAsterisk: {
    color: '#C62828',
  },
  formInput: {
    height: 38,
    borderWidth: 1,
    borderColor: AdminColors.gray100,
    borderRadius: 6,
    paddingHorizontal: 10,
    fontSize: 13,
    color: AdminColors.gray800,
    fontFamily: FontFamily.regular,
    backgroundColor: AdminColors.bgSurface,
  },
  optionsWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  optionChip: {
    borderRadius: 14,
    borderWidth: 1,
    borderColor: AdminColors.gray100,
    paddingHorizontal: 10,
    paddingVertical: 5,
    backgroundColor: AdminColors.bgSurface,
  },
  optionChipActive: {
    borderColor: AdminColors.blue700,
    backgroundColor: AdminColors.blue25,
  },
  optionChipText: {
    fontSize: 12,
    color: AdminColors.gray600,
    fontFamily: FontFamily.medium,
  },
  optionChipTextActive: {
    color: AdminColors.blue700,
  },
  statusToggle: {
    height: 38,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: AdminColors.gray100,
    backgroundColor: AdminColors.bgSurface,
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingHorizontal: 10,
    flexDirection: 'row',
    gap: 8,
  },
  statusToggleActive: {
    borderColor: AdminColors.green600,
    backgroundColor: '#F1FAEE',
  },
  statusSwitchTrack: {
    width: 44,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#C7CCD3',
    paddingHorizontal: 2,
    justifyContent: 'center',
  },
  statusSwitchTrackActive: {
    backgroundColor: AdminColors.green600,
  },
  statusSwitchKnob: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: '#EFEFEF',
    alignSelf: 'flex-start',
  },
  statusSwitchKnobActive: {
    backgroundColor: AdminColors.bgSurface,
    alignSelf: 'flex-end',
  },
  statusToggleText: {
    fontSize: 13,
    color: '#585C63',
    fontFamily: FontFamily.bold,
  },
  statusToggleTextActive: {
    color: AdminColors.green600,
  },
  kpiInputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  iconInputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  iconPreviewWrap: {
    width: 38,
    height: 38,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: AdminColors.gray100,
    backgroundColor: AdminColors.bgSurface,
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconDropdownMenu: {
    borderWidth: 1,
    borderColor: AdminColors.gray100,
    borderRadius: 6,
    backgroundColor: AdminColors.bgSurface,
    marginBottom: 8,
  },
  iconDropdownList: {
    maxHeight: 220,
  },
  iconDropdownOption: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: AdminColors.gray25,
  },
  iconDropdownOptionActive: {
    backgroundColor: AdminColors.blue25,
  },
  iconDropdownOptionText: {
    fontSize: 12,
    color: AdminColors.gray700,
    fontFamily: FontFamily.regular,
  },
  iconDropdownOptionTextActive: {
    color: AdminColors.blue700,
    fontFamily: FontFamily.medium,
  },
  iconDropdownEmptyText: {
    fontSize: 12,
    color: AdminColors.gray350,
    fontFamily: FontFamily.regular,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  kpiDropdownMenu: {
    borderWidth: 1,
    borderColor: AdminColors.gray100,
    borderRadius: 6,
    backgroundColor: AdminColors.bgSurface,
    marginBottom: 8,
  },
  kpiDropdownList: {
    maxHeight: 180,
  },
  kpiDropdownOption: {
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: AdminColors.gray25,
  },
  kpiDropdownOptionText: {
    fontSize: 12,
    color: AdminColors.gray700,
    fontFamily: FontFamily.regular,
  },
  kpiDropdownEmptyText: {
    fontSize: 12,
    color: AdminColors.gray350,
    fontFamily: FontFamily.regular,
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  kpiDropdownAddNew: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    borderTopWidth: 1,
    borderTopColor: AdminColors.gray25,
    paddingHorizontal: 10,
    paddingVertical: 8,
    backgroundColor: AdminColors.blue25,
  },
  kpiDropdownAddNewText: {
    fontSize: 12,
    color: AdminColors.blue700,
    fontFamily: FontFamily.medium,
  },
  removablePill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 14,
    backgroundColor: AdminColors.gray50,
  },
  removablePillText: {
    fontSize: 12,
    color: AdminColors.gray700,
    fontFamily: FontFamily.medium,
  },
  readOnlySection: {
    marginTop: 4,
    padding: 12,
    borderRadius: 6,
    backgroundColor: AdminColors.bgPage,
    borderWidth: 1,
    borderColor: AdminColors.gray50,
    marginBottom: 12,
  },
  readOnlyTitle: {
    fontSize: 11,
    color: AdminColors.gray350,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    fontFamily: FontFamily.bold,
    marginBottom: 8,
  },
  readOnlyItem: {
    fontSize: 12,
    lineHeight: 17,
    color: AdminColors.gray600,
    fontFamily: FontFamily.regular,
    marginBottom: 4,
  },
  noteWrap: {
    gap: 8,
  },
  noteText: {
    fontSize: 12,
    lineHeight: 17,
    color: AdminColors.gray600,
    fontFamily: FontFamily.regular,
    backgroundColor: AdminColors.blue25,
    borderWidth: 1,
    borderColor: AdminColors.blue75,
    borderRadius: 4,
    paddingHorizontal: 10,
    paddingVertical: 8,
  },
  // Save button shows inline loading; no modal overlay required.
});

export default styles;
